import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { SidenavService } from './shared/services/sidenav.service';

/**
 * The `ProjectTrackerSidenavContainerComponent` is used to display the drawer container.
 * It should be used along with the `SidenavService` to create an embedded view inside the container.
 *
 * @example
 * ```html
 * <project-tracker-sidenav-container style="z-index: 1002; position: sticky;">
 * </project-tracker-sidenav-container>
 * <ng-template #myTemplate>
 *   <div>This content will be embedded in the sidenav</div>
 * </ng-template>
 * ```
 *
 * ```ts
 * @ViewChild('myTemplate') myTemplate: TemplateRef<any>;
 * ...
 * // open the sidenav with the content from myTemplate
 * this.sidenavService.open(this.myTemplate);
 * ```
 */
@Component({
  selector: 'project-tracker-sidenav-container',
  templateUrl: './project-tracker-sidenav-container.component.html',
  styleUrls: ['./project-tracker-sidenav-container.component.scss'],
})
export class ProjectTrackerSidenavContainerComponent implements OnInit {
  @ViewChild('panel', { static: true }) private sidePanel: MatSidenav;
  @ViewChild('content', { static: true, read: ViewContainerRef }) private vcf: ViewContainerRef;

  constructor(private sidenavService: SidenavService) {}

  ngOnInit(): void {
    this.sidenavService.setPanel(this.sidePanel);
    this.sidenavService.setContentVcf(this.vcf);
  }
}
